module.exports = __webpack_public_path__ + "0b13478992020da6531f1c9f25ed7587.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/favicon-32x32.png
// module id = 2469
// module chunks = 84